export enum PriceListProfitMarginStatus {
    Active=1,
     InActive=0
}